import React from "react";
import "./style.css";
export function MainIcon(props) {
    return (React.createElement("div", { className: "main-icon-container" },
        React.createElement("img", { width: props.width, src: "./assets/icons/icon-small.png", alt: "Fotohub - strona g\u0142\u00F3wna", onClick: () => window.location.assign("./index.html"), className: "main-icon" })));
}
